import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex)

const state = {
	pw: null,
	flag: false,
	flag2: false,
	userId: null,
	name: null,
	list1:{
		flag:true,
		gz: '88',
	},
	list2:{
		flag:true,
		gz: '66',
	},
	list3:{
		flag:true,
		gz: '78',
	},
	list4:{
		flag:true,
		gz: '96',
	}
	
}

const mutations = {
	setPw(state, n) {
		state.pw = n
	},
	setFlag(state, n) {
		state.flag = n
	},
	setFlag2(state, n) {
		state.flag2 = n
	},
	setUserId(state, n) {
		state.userId = n
	},
	setName(state, n) {
		state.name = n
	},
	setList1(state, n) {
		state.list1 = n
	},
	setList2(state, n) {
		state.list2 = n
	},
	setList3(state, n) {
		state.list3 = n
	},
	setList4(state, n) {
		state.list4 = n
	}
}

const getters = {
	fruitsCount(state) {
		return state
	}
}
const plugins = [
	createPersistedState({
		// 存储方式：localStorage、sessionStorage、cookies
		storage: window.sessionStorage,
		// 存储的 key 的key值
		key: "store",
		reducer(state) { //render错误修改
			// 要存储的数据：本项目采用es6扩展运算符的方式存储了state中所有的数据
			return {
				...state
			};
		}
	})
]
export default new Vuex.Store({
	state,
	mutations,
	plugins
	// getters
})